import type { AnySchema, ISchema } from 'yup';
import type { RequiredWhenFieldCondition } from '../types/fieldCondition.types';
import { matchesFieldCondition } from './matchesFieldCondition';

export const requiredWhenAll = <TSchema extends AnySchema>(
	schema: TSchema,
	conditions: RequiredWhenFieldCondition[],
	resolve: (allMatch: boolean, schema: TSchema) => ISchema<unknown>
): TSchema =>
	schema.when(
		conditions.map((condition) => condition.fieldName),
		(values, currentSchema) =>
			resolve(
				conditions.every((condition, index) =>
					matchesFieldCondition(values[index], condition)
				),
				currentSchema
			)
	);
